export interface GenerateNewQuotationServiceResponse {
    numeroCotizacion: string;
}

export interface GenerateNewQuotationServiceRequest {
    articulo:                string;
    base:                    Base;
    codigoMoneda:            string;
    tipoOperacion:           string;
    subTipoOperacion:        string;
    subTipoOperacionSistema: string;
    superpolizaAfectada:     string;
}

export interface Base {
    empresa?:   string;
    sucursal?:  string;
    nivt?:      string;
    nivc?:      string;
    nit1?:      string;
    niv1?:      string;
}

export enum CurrencyCode {
    PESOS_ARGENTINOS = '01',
}

export enum OperationTypes {
    TIPO_OPERACION = '1',
    SUBTIPO_OPERACION = '0',
    SUBTIPO_OPERACION_SISTEMA = '0',
    SUPERPOLIZA_AFECTADA = '0'
}